<div class="tw-flex tw-items-stretch">
  <button
    (click)="fileInput.click()"
    class="tw-btn tw-btn-outline tw-rounded-e-none tw-border-e-0"
    type="button"
    title="Replace file"
  >
    <i class="bi bi-upload"></i>
  </button>
  <input
    type="text"
    (click)="fileInput.click()"
    class="hmm-input tw-flex-1 tw-rounded-none"
    placeholder="No file uploaded"
    [value]="formControl.value?.key"
    aria-label="file"
    readonly
  />
  @if (state === stateEnum.FileUploaded) {
    <button
      (click)="gotoViewableLink()"
      class="tw-btn tw-btn-outline tw-rounded-none tw-border-s-0"
      type="button"
      title="View file"
    >
      <i class="bi bi-eye"></i>
    </button>
    <button
      (click)="removeFile()"
      class="tw-btn tw-btn-danger -tw-ms-px tw-rounded-s-none"
      type="button"
      title="Remove file"
    >
      <i class="bi bi-trash"></i>
    </button>
  }
</div>
@if (state === stateEnum.FileUploading) {
  <div class="tw-flex tw-h-1 tw-overflow-hidden tw-rounded-full tw-bg-cloud-3">
    <div
      class="tw-flex tw-animate-pulse tw-items-center tw-justify-center tw-bg-leaf tw-transition-all"
      role="progressbar"
      [attr.aria-valuenow]="
        progressNumber[loadingState || loadingEnum.Selecting]
      "
      aria-valuemin="0"
      aria-valuemax="100"
      [ngStyle]="{
        'width.%': progressNumber[loadingState || loadingEnum.Selecting],
      }"
    ></div>
  </div>
}
@if (state === stateEnum.Error) {
  <dashboard-ui-error-message
    [message]="error || 'Error uploading file'"
  ></dashboard-ui-error-message>
}
<input
  class="hmm-input tw-sr-only"
  type="file"
  [accept]="accept"
  aria-label="file"
  [formlyAttributes]="field"
  (change)="onChange($event)"
  #fileInput
/>
